var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRedondo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 125,
    viewBox: "0 0 108 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108 31.1221L107.771 31.5195H108.001V93.7627H107.725L54 124.78L53.999 124.779L0.276367 93.7627H0V31.5195H0.229492L0 31.1221L53.9053 0L54 0.164062L54.0947 0L108 31.1221ZM14.0322 39.2227V85.502L54 108.577L93.9688 85.502V39.2227L61.0166 20.1982V71.5078H46.9844V20.1973L14.0322 39.2227ZM79.6611 35.8779V88.041H79.6172L79.6982 88.1816L54 103.019L53.9805 102.984L53.96 103.021L28.2607 88.1826L41.8545 79.8291L53.9785 86.8281L65.707 80.0566V28.3389L79.6611 35.8779Z",
    fill: "url(#paint0_linear_146_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_146_2",
    x1: 54.0005,
    y1: 8.99998,
    x2: 54.0005,
    y2: 124.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedondo);
export default __webpack_public_path__ + "static/media/logo_redondo.476d608e9379530e5d6b1243d1a7d906.svg";
export { ForwardRef as ReactComponent };